import { getDefaultFilter } from '~features/dashboard-filters';

import type { FindPaymentsRequestParams } from '~entities/payment/model/find-payments-params';

import type {
  ColumnActionOptions,
  ColumnSizingOptions,
  DashboardTableState,
} from '~shared/ui/dashboard-table';

import { ColumnId } from './columns';
import { filtersToParams } from './search-params-converters';

export const defaultState: DashboardTableState<ColumnId> = {
  pagination: { page: 0, rowsPerPage: 10 },
};

export const defaultSearchParams: FindPaymentsRequestParams = {
  page: 0,
  perPage: 10,
  filter: filtersToParams(getDefaultFilter()),
};

export const colSizingOptions: Record<ColumnId, ColumnSizingOptions> = {
  [ColumnId.STATUS]: { width: 180 },
  [ColumnId.AGREEMENT_ID]: { minWidth: 170, width: '20%' },
  [ColumnId.FINANCED_AMOUNT]: { minWidth: 130 },
  [ColumnId.POS]: { minWidth: 300, width: '30%' },
  [ColumnId.SETTLED_AMOUNT]: { minWidth: 130 },
  [ColumnId.ZERO_RATE_SUBSIDY]: { minWidth: 130 },
};

export const colActionOptions: Record<ColumnId, ColumnActionOptions> = {
  [ColumnId.STATUS]: { isSortable: true, sendAnalyticsEvent: true },
  [ColumnId.AGREEMENT_ID]: { isSortable: false },
  [ColumnId.ZERO_RATE_SUBSIDY]: { isSortable: false },
  [ColumnId.POS]: { isSortable: false },
  [ColumnId.FINANCED_AMOUNT]: { isSortable: false },
  [ColumnId.SETTLED_AMOUNT]: { isSortable: true },
};
